<h1>Slide toggle / Switch</h1>

<div class="row m-0 gap-3">
  <div class="col"></div>
  <div class="col">Default</div>
  <div class="col">Disabled</div>
  <div class="col">Hover</div>
  <div class="w-100"></div>
  <div class="col">Checked</div>
  <vitamui-slide-toggle class="col" [checked]="true"></vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [checked]="true" [disabled]="true"></vitamui-slide-toggle>
  <vitamui-slide-toggle class="col hover" [checked]="true"></vitamui-slide-toggle>
  <div class="w-100"></div>
  <div class="col">Unchecked</div>
  <vitamui-slide-toggle class="col" [checked]="false"></vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [checked]="false" [disabled]="true"></vitamui-slide-toggle>
  <vitamui-slide-toggle class="col hover" [checked]="false"></vitamui-slide-toggle>
  <div class="w-100"></div>
  <div class="col">Checked with text</div>
  <vitamui-slide-toggle class="col" [checked]="true">Text form option label</vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [checked]="true" [disabled]="true">Text form option label</vitamui-slide-toggle>
  <vitamui-slide-toggle class="col hover" [checked]="true">Text form option label</vitamui-slide-toggle>
  <div class="w-100"></div>
  <div class="col">Unchecked with text</div>
  <vitamui-slide-toggle class="col" [checked]="false">Text form option label</vitamui-slide-toggle>
  <vitamui-slide-toggle class="col" [checked]="false" [disabled]="true">Text form option label</vitamui-slide-toggle>
  <vitamui-slide-toggle class="col hover" [checked]="false">Text form option label</vitamui-slide-toggle>
</div>
